/**
 * Ensure grpinf always has groupDetails — bare { gr_id } breaks Home/Sessions UI.
 */
export function normalizeStoredGroupInfo(groupInfo, session = null) {
  const grId =
    groupInfo?.groupDetails?.gr_id ||
    groupInfo?.gr_id ||
    session?.gr_id ||
    null;
  if (!grId) return null;

  if (groupInfo?.groupDetails?.gr_id) {
    return groupInfo;
  }

  let stored = null;
  try {
    stored = JSON.parse(localStorage.getItem("grpinf") || "null");
  } catch {
    stored = null;
  }
  const storedId = stored?.groupDetails?.gr_id || stored?.gr_id;
  if (storedId === grId && stored?.groupDetails) {
    return stored;
  }

  const grName =
    groupInfo?.groupDetails?.gr_name ||
    groupInfo?.gr_name ||
    session?.gr_name ||
    stored?.groupDetails?.gr_name ||
    stored?.gr_name ||
    "";

  return {
    groupDetails: { gr_id: grId, gr_name: grName },
    gr_id: grId,
    gr_name: grName,
  };
}
